import React, { FC } from "react";
import {SvgIcon} from "../../SvgIcon/SvgIcon";

type CancellationMessageProps = {
  message: string;
};

export const CancellationMessage: FC<CancellationMessageProps> = ({
  message,
}) => {
  return (
    <div className="CancellationMessage">
      <SvgIcon iconName="info" className="CancellationMessage__icon" />
      <p
        className="CancellationMessage__content"
        dangerouslySetInnerHTML={{
            __html: message,
        }}
      />
    </div>
  );
};
